const productCache = {};
const imagePreloadCache = {};

const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "eager";
	return newImage;
};

const getProduct = (handle) => {
	if (productCache[handle]) {
		return Promise.resolve(productCache[handle]);
	}
	return fetch(window.Shopify.routes.root + "products/" + handle + ".js")
		.then(function (r) { return r.json(); })
		.then(function (product) {
			productCache[handle] = product;
			return product;
		});
};

const preloadVariantImages = (product) => {
	if (imagePreloadCache[product.handle]) return;
	imagePreloadCache[product.handle] = true;
	product.variants.forEach(function (variant) {
		if (variant.featured_media && variant.featured_media.preview_image) {
			var img = new Image();
			img.src = variant.featured_media.preview_image.src;
		}
	});
};

const swapImage = (wrapper, product, currentColor) => {
	const primaryImage = wrapper.querySelector(".media--first");
	const secondaryImage = wrapper.querySelector(".media--second");
	if (!primaryImage) return;

	const variant = product.variants.filter(
		(item) =>
			item.featured_media != null &&
			item.options.includes(currentColor)
	)[0];
	if (!variant) return;

	const newPrimaryImage = createImageElement(
		variant["featured_media"],
		primaryImage.className,
		primaryImage.sizes,
		product.title
	);

	if (newPrimaryImage.src === primaryImage.src) return;

	if (secondaryImage) {
		secondaryImage.remove();
	}

	primaryImage.replaceWith(newPrimaryImage);
};

const initSwatchesForContainer = (container) => {
	const wrappers = container.querySelectorAll
		? container.querySelectorAll(".js-color-swatches-wrapper")
		: [];
	wrappers.forEach((wrapper) => {
		if (wrapper.dataset.swatchBound) return;
		wrapper.dataset.swatchBound = "true";

		const handleProduct = wrapper.dataset.product;

		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				if (!event.currentTarget.checked) return;

				wrapper
					.querySelectorAll(".js-color-swatches-link")
					.forEach((item) =>
						item.setAttribute("href", event.currentTarget.dataset.variantLink)
					);

				const currentColor = event.currentTarget.value;
				getProduct(handleProduct).then(function (product) {
					swapImage(wrapper, product, currentColor);
				});
			});
		});

		// Prefetch product data + preload variant images on hover/touch
		const prefetch = function () {
			getProduct(handleProduct).then(function (product) {
				preloadVariantImages(product);
			});
		};
		wrapper.addEventListener("mouseenter", prefetch, { once: true });
		wrapper.addEventListener("touchstart", prefetch, { once: true, passive: true });
	});
};

const checkSwatches = () => {
	initSwatchesForContainer(document);
};

// Auto-prefetch visible product cards using IntersectionObserver
const prefetchVisible = () => {
	if (!("IntersectionObserver" in window)) return;
	const observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				const handle = entry.target.dataset.product;
				if (handle && !productCache[handle]) {
					getProduct(handle).then(function (product) {
						preloadVariantImages(product);
					});
				}
				observer.unobserve(entry.target);
			}
		});
	}, { rootMargin: "200px" });

	document.querySelectorAll(".js-color-swatches-wrapper:not([data-prefetch-observed])").forEach(function (el) {
		el.dataset.prefetchObserved = "true";
		observer.observe(el);
	});
};

// Watch for dynamically added product cards (related products, tabs, AJAX sections)
const watchForNewCards = () => {
	if (!("MutationObserver" in window)) return;
	const observer = new MutationObserver(function (mutations) {
		let hasNewCards = false;
		for (let i = 0; i < mutations.length; i++) {
			const added = mutations[i].addedNodes;
			for (let j = 0; j < added.length; j++) {
				if (added[j].nodeType === 1) {
					if (added[j].classList && added[j].classList.contains("js-color-swatches-wrapper")) {
						hasNewCards = true;
						break;
					}
					if (added[j].querySelector && added[j].querySelector(".js-color-swatches-wrapper")) {
						hasNewCards = true;
						break;
					}
				}
			}
			if (hasNewCards) break;
		}
		if (hasNewCards) {
			checkSwatches();
			prefetchVisible();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });
};

function colorSwatches() {
	checkSwatches();
	prefetchVisible();
	watchForNewCards();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		prefetchVisible();
	});
}

(function () {
	colorSwatches();
})();
